<template>
  <div class="orders">
    <div class="orders__top">
      <h6 class="orders__title">{{ t('profile.orders.title') }}</h6>
      <div class="orders__top-buttons">
        <ui-button
            @click="setBuyTimeOrdering"
            :class="[{ active: orderBy.includes('buy_time') }]"
            class="orders__top-button"
        >
          {{ t('profile.orders.time') }}
          <svg :class="[{ rotate: orderBy === '-buy_time' }]" xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 12 17" fill="none">
            <path d="M5.25 15.4287C5.25 15.8429 5.58579 16.1787 6 16.1787C6.41421 16.1787 6.75 15.8429 6.75 15.4287L5.25 15.4287ZM6.53033 1.1841C6.23744 0.891202 5.76256 0.891202 5.46967 1.1841L0.696699 5.95707C0.403805 6.24996 0.403805 6.72483 0.696699 7.01773C0.989592 7.31062 1.46447 7.31062 1.75736 7.01773L6 2.77509L10.2426 7.01773C10.5355 7.31062 11.0104 7.31062 11.3033 7.01773C11.5962 6.72483 11.5962 6.24996 11.3033 5.95707L6.53033 1.1841ZM6 15.4287L6.75 15.4287L6.75 1.71443L6 1.71443L5.25 1.71443L5.25 15.4287L6 15.4287Z" fill="currentColor"/>
          </svg>
        </ui-button>
        <ui-button
            class="orders__top-button"
            @click="setStatusOrdering"
            :class="[{ active: orderBy.includes('status') }]"
        >
          {{ t('profile.orders.status') }}
          <svg :class="[{ rotate: orderBy === '-status' }]" xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 12 17" fill="none">
            <path d="M5.25 15.4287C5.25 15.8429 5.58579 16.1787 6 16.1787C6.41421 16.1787 6.75 15.8429 6.75 15.4287L5.25 15.4287ZM6.53033 1.1841C6.23744 0.891202 5.76256 0.891202 5.46967 1.1841L0.696699 5.95707C0.403805 6.24996 0.403805 6.72483 0.696699 7.01773C0.989592 7.31062 1.46447 7.31062 1.75736 7.01773L6 2.77509L10.2426 7.01773C10.5355 7.31062 11.0104 7.31062 11.3033 7.01773C11.5962 6.72483 11.5962 6.24996 11.3033 5.95707L6.53033 1.1841ZM6 15.4287L6.75 15.4287L6.75 1.71443L6 1.71443L5.25 1.71443L5.25 15.4287L6 15.4287Z" fill="currentColor"/>
          </svg>
        </ui-button>
      </div>
    </div>
    <div class="orders__main">
      <div class="orders__main-wrapper">
        <div class="orders__main-top">
          <p class="orders__order">{{ t('profile.orders.order') }}</p>
          <p class="orders__status">{{ t('profile.orders.status') }}</p>
          <p class="orders__products">{{ t('profile.orders.products') }}</p>
          <p class="orders__date">{{ t('profile.orders.date') }}</p>
        </div>
        <div class="orders__main-list">
          <div
              v-for="order in orders"
              :key="order.node.uuid"
              class="orders__item"
              v-if="orders.length > 0"
          >
            <p class="orders__order">{{ order.node.humanReadableId }}</p>
            <p class="orders__status">{{ order.node.status }}</p>
            <div class="orders__item-products orders__products">
              <div class="orders__item-product" v-for="product in order.node.orderProducts.edges" :key="product.node.product.uuid">
                <img class="orders__item-product-image" :src="product.node.product.images.edges[0].node.image" :alt="product.node.product.name">
                <div>
                  <p class="orders__item-product-name">{{ product.node.product.name }}</p>
                  <p><img src="@icons/currency.svg" alt="currency">{{ product.node.product.price }}</p>
                </div>
                <a :href="product.node.downloadUrl" :download="product.node.downloadUrl" v-if="order.node.status === 'FINISHED'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                    <path d="M1 19.3529V22.1765C1 22.9253 1.3029 23.6435 1.84207 24.173C2.38123 24.7025 3.1125 25 3.875 25H21.125C21.8875 25 22.6188 24.7025 23.1579 24.173C23.6971 23.6435 24 22.9253 24 22.1765V19.3529M5.3125 10.8824L12.5 17.9412M12.5 17.9412L19.6875 10.8824M12.5 17.9412V1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
                <svg v-else class="not" xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
                  <path d="M1 19.3529V22.1765C1 22.9253 1.3029 23.6435 1.84207 24.173C2.38123 24.7025 3.1125 25 3.875 25H21.125C21.8875 25 22.6188 24.7025 23.1579 24.173C23.6971 23.6435 24 22.9253 24 22.1765V19.3529M5.3125 10.8824L12.5 17.9412M12.5 17.9412L19.6875 10.8824M12.5 17.9412V1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <p class="orders__date">{{ dayjs(order.node.buyTime).format('MM/D/YY HH:mm') }}</p>
          </div>
          <p class="orders__loading" v-else-if="isLoading">Loading...</p>
          <p v-else class="orders__empty">{{ t('profile.orders.empty') }}</p>
        </div>
      </div>
    </div>
    <ui-button
        class="orders__button"
        @click="getMoreOrders"
        v-if="orders.length > 0"
    >
      {{ t('buttons.showMore') }}
    </ui-button>
  </div>
</template>

<script setup>
import UiButton from "@/components/ui/ui-button.vue";
import {useI18n} from "vue-i18n";
import {computed, onMounted, ref, watch} from "vue";
import {useAuthStore} from "@/stores/auth.js";
import {Orders} from "@/core/api/orders.js";
import dayjs from "dayjs";
import {useRoute} from "vue-router";

const {t} = useI18n();
const route = useRoute()
const authStore = useAuthStore()

const userEmail = computed(() => {
  return authStore.user ? authStore.user?.email : null
})
const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : null
})

const isLoading = ref(true)

const orders = ref([])
const pageInfo = ref([])
const cursorForAfter = ref('')
const orderBy = ref(route.query['orderBy'] ? (route.query['orderBy']) : '')

const query = computed(() => {
  let res =`?orderBy=${orderBy.value}`

  return res
})

const toggleOrdering = (type) => {
  const currentType = orderBy.value.startsWith('-') ? orderBy.value.slice(1) : orderBy.value;
  orderBy.value = (currentType === type) ? (orderBy.value.startsWith('-') ? type : `-${type}`) : type;
};
const setStatusOrdering = () => toggleOrdering('status');
const setBuyTimeOrdering = () => toggleOrdering('buy_time');

const getOrders = async () => {
  isLoading.value = true
  cursorForAfter.value = '0'

  const res = await Orders.getProfileOrders(
      `after: "${cursorForAfter.value}"` +
      `, first: 4` +
      `, userEmail: "${userEmail.value}"` +
      `, orderBy: "${orderBy.value}"`,
      accessToken.value
  )
  orders.value = res.data.orders?.edges
      .filter((order) => order.node.status !== 'PENDING')
  pageInfo.value = res.data?.orders?.pageInfo

  isLoading.value = false
}

const getMoreOrders = async () => {
  if (pageInfo.value.hasNextPage) {
    isLoading.value = true

    cursorForAfter.value = pageInfo.value.endCursor

    const res = await Orders.getProfileOrders(
        `after: "${cursorForAfter.value}"` +
        `, first: 4` +
        `, userEmail: "${userEmail.value}"` +
        `, orderBy: "${orderBy.value}"`,
    )
    let newOrders = res.data.orders?.edges
        .filter((order) => order.node.status !== 'PENDING')

    orders.value.push(...newOrders)
    pageInfo.value = res.data.orders.pageInfo

    isLoading.value = false
  }
}

watch(
    () => query.value,
    async () => {
      orders.value = [];
      history.pushState({}, '', route.path + query.value);
      await getOrders();
    }
)

onMounted( async () => {
  await getOrders()
});
</script>

<style lang="scss" scoped>
.orders {
  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-buttons {
      display: flex;
      align-items: center;
      gap: 15px;
    }

    &-button {
      width: fit-content;
      padding-inline: 15px;
      text-transform: lowercase;

      &.active {
        background-color: $white;
        color: $black;
      }

      & svg {
        transition: 0.2s;

        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
  }

  &__title {
    color: #F3F3F3;
    font-size: 40px;
    font-weight: 700;
  }

  &__main {
    margin-top: 30px;
    padding-bottom: 15px;
    border-bottom: 3px solid $white;

    &-wrapper {

    }

    &-top {
      padding: 0 15px 15px 15px;
      border-bottom: 3px solid $white;
      display: flex;
      align-items: center;

      & p {
        color: #F3F3F3;
        font-size: 20px;
      }
    }
  }

  &__order {
    width: 12%;
  }

  &__status {
    width: 12%;
  }

  &__products {
    width: 61%;
  }

  &__date {
    width: 15%;
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid $white;

    &:last-child {
      border-bottom: none;
    }

    & p {
      color: #F3F3F3;
      font-size: 18px;
    }

    &-products {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }

    &-product {
      display: flex;
      align-items: center;
      gap: 15px;

      &-image {
        width: 150px;
      }

      &-name {
        max-width: 275px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      & div {
        display: flex;
        flex-direction: column;
        gap: 5px;

        & p {
          display: flex;
          align-items: center;
          gap: 5px;
        }
      }

      & svg {
        flex-shrink: 0;
        margin-inline: auto 40px;
        cursor: pointer;
        transition: 0.2s;
        color: $white;

        @include hover {
          color: #a1a1a1;
        }

        &.not {
          cursor: not-allowed !important;

          @include hover {
            color: $white;
          }
        }
      }
    }
  }

  &__button {
    width: fit-content;
    padding-inline: 25px;
    margin-inline: auto;
    margin-top: 30px;
  }

  &__loading {
    margin-top: 30px;
    color: #F3F3F3;
    font-size: 20px;
  }

  &__empty {
    margin-top: 30px;
    color: #F3F3F3;
    text-align: center;
    font-size: 40px;
    font-weight: 700;
  }
}

@media (max-width: 900px) {
  .orders {
    &__main {
      overflow-x: auto;

      &-wrapper {
        width: 900px;
      }
    }
  }
}

@media (max-width: 750px) {
  .orders {
    &__top {
      flex-direction: column;
      align-items: flex-start;
      gap: 25px;
    }
  }
}

@media (max-width: 500px) {
  .orders {
    &__top {
      &-buttons {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
      }
    }
  }
}
</style>